import { useAuth } from '@/auth/auth-provider'
import { defaultPostLoginPath } from '@/auth/principal'
import loginBackground from '@/assets/images/login_background.jpg'
import {
    Box,
    Button,
    Center,
    Loader,
    Paper,
    Stack,
    Text,
    Title
} from '@mantine/core'
import React, { useState } from 'react'
import { Navigate } from 'react-router-dom'

export const LoginPage = () => {
  const { signIn, isLoading, isAuthenticated } = useAuth()
  const [isLoggingIn, setIsLoggingIn] = useState(false)
  const postLoginPath = defaultPostLoginPath()

  if (!isLoading && isAuthenticated) {
    return <Navigate to={postLoginPath} replace />
  }

  const handleLogin = async (e?: React.FormEvent) => {
    e?.preventDefault()
    setIsLoggingIn(true)
    try {
      await signIn()
    } catch (error) {
      console.error('Login error:', error)
      setIsLoggingIn(false)
    }
  }

  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    )
  }

  return (
    <Box
      className="auth-page-container"
      style={{
        backgroundImage: `url(${loginBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Overlay gradient */}
      <Box
        pos="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        style={{
          background: 'linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(0,100,200,0.3) 100%)',
        }}
      />

      <Box className="auth-container">
          <Paper className="auth-paper" withBorder>
            <Stack className="auth-stack">
              {/* Header */}
              <Box className="auth-header">
                <Title order={1} className="auth-title">
                  AI  Dashboard
                </Title>
                <Text className="auth-subtitle">
                  Access tools for customer engagement, appointment scheduling, and business analytics.
                </Text>
              </Box>

                      {/* Login Form */}
                      <form onSubmit={handleLogin}>
                        <Stack className="auth-stack">
                          <Button
                            type="submit"
                            fullWidth
                            size="xl"
                            loading={isLoggingIn}
                            color="orange"
                            className="auth-button-primary"
                          >
                            Continue to Sign In
                          </Button>
                        </Stack>
                      </form>

              {/* Footer */}
              <Box className="auth-footer">
                <Text 
                  className="auth-footer-link"
                  onClick={() => window.location.href = '/forgot-password'}
                >
                  Forgot Password?
                </Text>

                <Text className="auth-footer-text-small">
                  Need help?{' '}
                  <Text 
                    component="a" 
                    href="mailto:support@dealership.com" 
                    className="auth-footer-link-inline"
                  >
                    Contact Support
                  </Text>
                </Text>
              </Box>
            </Stack>
          </Paper>
        </Box>
    </Box>
  )
}
